import qrCode from "qrcode";
import { chunkText } from "@/utils/pureFunctions.js";

const QR_SIZE = 35;
const QR_OPTIONS = {
  errorCorrectionLevel: "M",
  type: "image/jpeg",
  quality: 0.5,
  margin: 1,
  color: {
    dark: "#000000",
    light: "#ffffff",
  },
};

export class LotTemplate {
  constructor() {
    this.width = 0;
    this.height = 0;
    this.texts = [];
    this.qr = null;
    this.canAddText = true;
  }

  /**
   *
   * @param {string} text
   */
  addText(text) {
    if (this.canAddText && text) {
      chunkText(text, 22).forEach((item) => {
        if (this.texts.length < 5) {
          this.texts.push(item);
        } else {
          this.texts[this.texts.length - 1] =
            this.texts[this.texts.length - 1] + "...";
          this.canAddText = false;
        }
      });
    }
  }

  async addQr(data, color = "#000000") {
    return new Promise((resolve) => {
      QR_OPTIONS.color.dark = color;
      qrCode.toDataURL(data, QR_OPTIONS, (err, url) => {
        if (!err) {
          this.height += 50;
          this.width += QR_SIZE;
          this.qr = url;
        }
        resolve();
      });
    });
  }

  get data() {
    return {
      texts: this.texts,
      qr: this.qr,
      qrSize: QR_SIZE,
      size: {
        width: this.width,
        height: this.height,
      },
    };
  }
}
